// 前缀 --> 默认路由、高亮
// 前缀也支持 'prefix/sub/' 的字符串形式
const RouteMap = {
	'default': { // 默认
		defaultRoute: '/instance/game/list',
		highlight: 'cpsGameList'
	},
  	'/instance/retail': { // 零售中台实例
		defaultRoute: '/instance/retail/list',
		highlight: 'retailInstanceList'
  	},
  	'instance/basic': { // 基础网络实例
		defaultRoute: '/instance/basic/list',
		highlight: 'instancebasic'
  	},
  	'instance/vpc': { // 私有网络实例
		defaultRoute: '/instance/vpc/list',
		highlight: 'cpsVpcInstanceList'
  	},
    'instance/game': { // 游戏实例
		defaultRoute: '/instance/game/list',
		highlight: 'cpsGameList'
  	},
  	'image': { // 镜像
		defaultRoute: '/image/list',
		highlight: 'cpsImageList'
  	},
  	'vpc': { // 私有网络
		defaultRoute: '/vpc/list',
		highlight: 'cpsVpcList'
  	},
  	'nat': {// NAT网关
		defaultRoute: '/nat/list',
		highlight: 'cpsnatList'
  	},
  	'peering': { // 对等连接
		defaultRoute: '/peering/list',
		highlight: 'cpsPeeringList'
  	},
  	'subnet': { // 子网
		defaultRoute: '/subnet/list',
		highlight: 'cpsSubnetList'
  	},
  	'eip': { // 弹性公网IP
		defaultRoute: '/eip/list',
		highlight: 'cpsEipList'
  	},
  	'sbw': {
		defaultRoute: '/sbw/list',
		highlight: 'cpsbwList'
  	},
	'lb': {
		defaultRoute: '/lb/list',
		highlight: 'lbList'
	},
	'lb/cert/': {
		defaultRoute: '/lb/cert/list',
		highlight: 'lbcertList'
	},
	'routeTable': { // 路由表
		defaultRoute: '/routeTable/list',
		highlight: 'routeTableList'
	},
	// SSH密钥登录
	'ssh': {
		defaultRoute: '/ssh/list',
		highlight: 'sshList'
	},
	// ipv6
	'ipv6': {
		defaultRoute: '/ipv6/list',
		highlight: 'ipv6List'
	},
};

const _getConfig = (key) => {
	if (!key) return null;
	const m = Object.keys(RouteMap).reduce((obj, k) => {
		obj[k.toLowerCase()] = {
			_key: k,
			...RouteMap[k]
		};
		return obj;
	}, {});
	return m[key.toLowerCase()];
};

const _splitRoute = (route) => {
	let prefix;
	let rest;
	const findMap = Object.keys(RouteMap).filter((key) => {
		key = key.replace(/\/+$/, '').replace(/^\/+/, ''); // 去掉首尾斜杠
		if (/^\//.test(route)) key = `/${key}`;
		const re = new RegExp(`^(${key.toLowerCase()})/`, 'i');
		return re.test(route);
	});
	if (findMap.length) {
		prefix = findMap.length > 1 ? findMap[1] : findMap[0];
		const preLng = prefix.length + /^(\/*)/.exec(route)[1].length;
		rest = route.substr(preLng).replace(/\/+$/, '').replace(/^\//, '');
	} else {
		const reTest = /^\/?(.*?)\/(.*)$/.test(route);
		prefix = reTest ? RegExp.$1 : null;
		rest = reTest ? RegExp.$2 : null;
	}
	return {
		prefix,
		rest
	};
};

export function getRoutePath (from) {
	if (/^\/cps_api\/api\/export\//.test(from)) { // 依靠刷新页面实现的传统“导出”的特殊路由
		return from;
	}
	let to = from;
	const reTest = _splitRoute(from);
	const { prefix, rest } = reTest;
	const cfg = reTest
		? _getConfig(prefix)
		: false;
	if (!reTest || !cfg) { // 不是合法的路由格式
		to = RouteMap.default.defaultRoute;
	} else if (cfg) {
		console.log(from, prefix, rest, cfg._key);
		if (rest === '(.*)') {
		// 兼容上一版菜单的配置
		to = cfg.defaultRoute;
		} else {
		// 修正可能的小写，补全开头斜杠
		const pre = new RegExp(`^/*${prefix}`, 'i');
		to = to.replace(pre, cfg._key).replace(/^\/*/, '/');
		}
	}
	return to;
}

export function getHighlight (from) {
	const reTest = _splitRoute(from);
	if (!reTest) return RouteMap.default.highlight;

	const { prefix } = reTest;
	const cfg = _getConfig(prefix);

	return cfg ? cfg.highlight : RouteMap.default.highlight;
}

export default function(router) {
	// 应 fanyang@jd.com 的要求增加的代码
	// 用于匹配新的 jq 控制台菜单组件
	// 在页面路由切换时不至刷新页面
	window.toRoutePath = function (from, highlightOnly = false) {
		console.log('菜单传入的路径：', from);

		if (!from || !from.length) return;

		// 1. 菜单高亮
		const hl = getHighlight(from);
		if (typeof window.Ynavi !== 'undefined') {
		setTimeout(() => {
			Ynavi.setCurrPage(hl); // eslint-disable-line no-undef
		}, 200);
		}

		console.log('\t菜单高亮：', hl);

		if (highlightOnly) return;

		// 2. 修正跳转
		const to = getRoutePath(from);
		router.push(to);

		console.log('\t实际跳转到：', to);
	};
	window.addEventListener('DOMContentLoaded', () => {
		const { pathname, search, hash } = window.location;
		window.toRoutePath(`${pathname}${search}${hash}`); // 会自动都转为小写
	});
}



// WEBPACK FOOTER //
// ./src/router/menuChecker.js